import {
  BUSINESS_CATEGORY_INTERNAL_NAMES,
  BUSINESS_STATUSES,
  LOGIN_TYPES,
  PRICE_TYPES,
} from '@/lib/consts.js'

export const ONBOARDING_USER_ROLE = 'Owner'

export const DEFAULT_CURRENCY = 'USD'

export const DEVICE = {
  www: 'www',
  ios: 'ios',
  android: 'android',
}

export const DEVICE_TYPE = {
  [DEVICE.www]: 'Desktop',
  [DEVICE.android]: 'Android',
  [DEVICE.ios]: 'iOS',
  Tablet: 'Tablet',
}

export const PRICE_TYPE = {
  [PRICE_TYPES.FIXED]: 'fixed',
  [PRICE_TYPES.VARIES]: 'varies',
  [PRICE_TYPES.DONT_SHOW]: 'don\'t show',
  [PRICE_TYPES.FREE]: 'free',
  [PRICE_TYPES.STARTS_AT]: 'starts at',
}

export const HANDLER_NAMES = {
  SMARTLOOK_BUSINESS: 'SmartlookBusiness',
  GTM_1: 'dataLayer', // name must be 'dataLayer' because of gtm library requirements
  ANALYTICS: 'analytics', // name must be 'analytics' because of segment library requirements
  DEBUG: 'Debug',
  GOOGLE_ANALYTICS: 'GoogleAnalytics',
  WEB_VIEW_HANDLER_1: 'WebViewHandler1',
}

export const KYC_STATUS = {
  STARTED: 'STARTED',
}

export const REGISTRATION_METHODS = {
  [LOGIN_TYPES.APPLE]: 'apple_id',
  [LOGIN_TYPES.ACCESS_TOKEN]: 'access_token',
  [LOGIN_TYPES.AUTH_TOKEN]: 'auth_token',
  [LOGIN_TYPES.DEFAULT]: 'email',
  [LOGIN_TYPES.FACEBOOK]: 'facebook',
  [LOGIN_TYPES.GOOGLE]: 'google',
}

export const DEFAULT_PAYLOAD = Symbol('default-payload')

export const BUSINESS_STATUS_NAMES = {
  [BUSINESS_STATUSES.SETUP]: 'SETUP',
  [BUSINESS_STATUSES.TRIAL]: 'TRIAL',
  [BUSINESS_STATUSES.TRIAL_BLOCKED]: 'TRIAL_BLOCKED',
  [BUSINESS_STATUSES.PAID_ACTIVE]: 'PAID',
  [BUSINESS_STATUSES.ACTIVE_OVERDUE]: 'OVERDUE',
  [BUSINESS_STATUSES.BLOCKED_OVERDUE]: 'BLOCKED_OVERDUE',
  [BUSINESS_STATUSES.CHURNED]: 'CHURNED',
  [BUSINESS_STATUSES.SUSPENDED]: 'SUSPENDED',
  [BUSINESS_STATUSES.BUSINESS_INVALID]: 'BLOCKED',
  [BUSINESS_STATUSES.VENUE]: 'VENUE',
  [BUSINESS_STATUSES.B_LISTING]: 'B_LISTING',
  [BUSINESS_STATUSES.DEMO]: 'DEMO',
  [BUSINESS_STATUSES.DEMO_TEMPLATE]: 'DEMO_TEMPLATE',
}

export const SENDING_SKIPPED = Symbol('sending-skipped')

export const BUSINESS_REGISTRATION_STARTED_EVENTS = {
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BARBERS]: 'Barber_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HAIR_SALONS]: 'Hair_Salon_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.THERAPY]: 'Physical_Therapy_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.SKIN_CARE]: 'Skin_Care_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.NAIL_SALONS]: 'Nail_Salon_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BROWS_AND_LASHES]: 'Brows&Lashes_Registration_Started',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.OTHER]: 'Other_Registration_Started',
}

export const BUSINESS_REGISTRATION_COMPLETED_EVENTS = {
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BARBERS]: 'Barber_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HAIR_SALONS]: 'Hair_Salon_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.NAIL_SALONS]: 'Nail_Salon_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.OTHER]: 'Other_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BROWS_AND_LASHES]: 'Brows&Lashes_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.SKIN_CARE]: 'Skin_Care_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.THERAPY]: 'Physical_Therapy_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BRAIDS]: 'Braids_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PROFESSIONAL_SERVICES]: 'Prof_Services_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.AESTHETIC_MEDICINE]: 'Aesthetic_Med_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.MASSAGE]: 'Massage_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.MAKE_UP]: 'Make-up_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HOME_SERVICES]: 'Home_services_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.DAY_SPA]: 'Day_SPA_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PERSONAL_TRAINERS]: 'Personal_trainers_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.TATOO_ARTISTS]: 'Tattoo_artists_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PET_SERVICES]: 'Pet_services_Registration_Completed',
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HEALTH_AND_WELLNESS]: 'Health&Wellness_Registration_Completed',
}

// Must be a string, because mergeDeepRight from ramda doesn't merge symbols
export const USE_IDENTIFY = 'USE_IDENTIFY'

export const EVENT_ACTIONS = {
  VIEW_OPENED: 'view_opened',
  UNSUBSCRIBE_CLICKED: 'unsubscribe_clicked',
  BACK_CLICKED: 'back_clicked',
  SUBSCRIBE_CLICKED: 'subscribe_clicked',
  NEXT_CLICKED: 'next_clicked',
  SHARE_CLICKED: 'share_clicked',
  CHANNEL_CLICKED: 'channel_clicked',
  DOWNLOAD_CLICKED: 'download_clicked',
  LOGOUT_CLICKED: 'logout_clicked',
  CANCEL_CLICKED: 'cancel_clicked',
  PAY_CLICKED: 'pay_clicked',
  RETRY_CLICKED: 'retry_clicked',
  RENEW_CLICKED: 'renew_clicked',
  UPDATE_CLICKED: 'update_clicked',
  CONTACT_CLICKED: 'contact_clicked',
  CALL_CLICKED: 'call_clicked',
  CLOSE_CLICKED: 'close_clicked',
  CHOOSE_CLICKED: 'choose_clicked',
  CHANGE_CLICKED: 'change_clicked',
  COPY_LINK_CLICKED: 'copy_link_clicked',
  PROCEED_CLICKED: 'proceed_clicked',
  ADD_TO_FAVOURITES_CLICKED: 'add_to_favourites_clicked',
  REMOVE_FROM_FAVOURITES_CLICKED: 'remove_from_favourites_clicked',
  RESET_CLICKED: 'reset_clicked',
  PROCEED_YES_CLICKED: 'proceed_yes_clicked',
  PROCEED_NO_CLICKED: 'proceed_no_clicked',
  SKIP_CLICKED: 'skip_clicked',
  INFO_CLICKED: 'info_clicked',
  BOOST_INFO_CLICKED: 'boost_info_clicked',
  ITEM_CLICKED: 'item_clicked',
  DATE_CLICKED: 'date_clicked',
  VIEW_PROFILE_CLICKED: 'view_profile_clicked',
  PROFILE_IMAGES_CLICKED: 'profile_images_clicked',
  PORTFOLIO_CLICKED: 'portfolio_clicked',
  SERVICES_CLICKED: 'services_clicked',
  SERVICE_CLICKED: 'service_clicked',
  EXISTING_SERVICE_CLICKED: 'existing_service_clicked',
  NEW_CATEGORY_CLICKED: 'new_category_clicked',
  NEW_COMBO_CLICKED: 'new_combo_clicked',
  ADD_CLICKED: 'add_clicked',
  ADD_VARIANT_CLICKED: 'add_variant_clicked',
  STAFF_MEMBERS_CLICKED: 'staff_members_clicked',
  NO_SHOW_PROTECTION_CLICKED: 'no_show_protection_clicked',
  SETTINGS_CLICKED: 'settings_clicked',
  FOR_CLIENT_CLICKED: 'for_client_clicked',
  DELETE_CLICKED: 'delete_clicked',
  ADDON_CLICKED: 'addon_clicked',
  BUSINESS_DETAILS_CLICKED: 'business_details_clicked',
  RECEIPT_CLICKED: 'receipt_clicked',
  UPLOAD_DEVICE: 'upload_device',
  UPLOAD_INSTAGRAM: 'upload_instagram',
  PORTFOLIO_MORE_CLICKED: 'portfolio_more_clicked',
  DISCARD_EXIT: 'discard_exit',
  UPLOAD_FINISHED: 'upload_finished',
  YES_CLICKED: 'yes_clicked',
  NO_CLICKED: 'no_clicked',
  UPDATE_PAYMENT_METHOD_CLICKED: 'update_payment_method_clicked',
  CARD_DENIED: 'card_denied',
  INVITE_IMPORT_CLICKED: 'invite_import_clicked',
  SPC_CLICKED: 'spc_clicked',
  MB_CLICKED: 'mb_clicked',
  PROMOTIONS_CLICKED: 'promotions_clicked',
  BLACK_FRIDAY_BANNER_CLICKED: 'black_friday_banner_clicked',
  PLAY_CLICKED: 'play_clicked',
  BOOST_CLICKED: 'boost_clicked',
  SELECT_YOUR_PLAN_CLICKED: 'select_your_plan_clicked',
  TOAST_MESSAGE: 'toast_message',
  PROFILE_COMPLETENESS_CLICKED: 'profile_completeness_clicked',
  FAST_CHARGE_CLICKED: 'fast_charge_clicked',
  TARGET_CLICKED: 'target_clicked',
  PUBLISH_PROFILE_CLICKED: 'publish_profile_clicked',
  CANT_REMEMBER_PASSWORD: 'cant_remember_password',
  USER_LOGGED: 'user_logged',
  USER_LOGGED_OUT: 'user_logged_out',
  LOGIN_FAILED: 'login_failed',
  LANDING_PAGE_CLICKED: 'landing_page_clicked',
  REQUEST_DEACTIVATION_CLICKED: 'request_deactivation_clicked',
  DEACTIVATE_CLICKED: 'deactivate_clicked',
  DETAILS_CLICKED: 'details_clicked',
  REPORTS_CLICKED: 'reports_clicked',
  GET_NOTICED_COVER_CLICKED: 'get_noticed_cover_clicked',
  GET_NOTICED_PORTFOLIO_CLICKED: 'get_noticed_portfolio_clicked',
  SHARE_YOUR_LINK_CLICKED: 'share_your_link_clicked',
  TERMS_CLICKED: 'terms_clicked',
  DEACTIVATED_PAGER_MORE_CLICKED: 'deactivated_pager_more_clicked',
  REACTIVATE_CLICKED: 'reactivate_clicked',
  SHARED: 'shared',
  INSTAGRAM_CLICKED: 'instagram_clicked',
  GOOGLE_CLICKED: 'google_clicked',
  FACEBOOK_CLICKED: 'facebook_clicked',
  WEBSITE_CLICKED: 'website_clicked',
  SEARCH_VISIBILITY_CLICKED: 'search_visibility_clicked',
  HIDE_BOOKING_CLICKED: 'hide_booking_clicked',
  BUSINESS_CLICKED: 'business_clicked',
  STAFFER_CLICKED: 'staffer_clicked',
  FIND_MORE_CLICKED: 'find_more_clicked',
  CONNECT_CLICKED: 'connect_clicked',
  DISCONNECT_CLICKED: 'disconnect_clicked',
  MANAGE_CLICKED: 'manage_clicked',
  COPY_CLICKED: 'copy_clicked',
  EMAIL_CLICKED: 'email_clicked',
  GOOGLE_RESTRICTION_CLICKED: 'google_restriction_clicked',
  ENABLE_CLICKED: 'enable_clicked',
  DISABLE_CLICKED: 'disable_clicked',
  REFUND_CLICKED: 'refund_clicked',
  SCROLLED_DOWN: 'scrolled_down',
  // [eppo] Experiment_Action/Variation_Assigned
  VARIATION_ASSIGNED: 'variation_assigned',

  ACCOUNT_CHANGED: 'account_changed',

  SCAN_FLYER_CLICKED: 'scan_flyer_clicked',
  FROM_SCRATCH_CLICKED: 'from_scratch_clicked',
  TRANSFER_SERVICES_CLICKED: 'transfer_services_clicked',
  SCAN_FLYER_STARTED: 'scan_flyer_started',
  SCAN_FLYER_COMPLETED: 'scan_flyer_completed',
  SCAN_FLYER_FAILED: 'scan_flyer_failed',
  LOGIN_EMAIL_CLICKED: 'login_email_clicked',
  LOGIN_GOOGLE_CLICKED: 'login_google_clicked',
  LOGIN_FACEBOOK_CLICKED: 'login_facebook_clicked',
  LOGIN_APPLE_CLICKED: 'login_apple_clicked',
  LOGIN_CLICKED: 'login_clicked',
  SIGNUP_CLICKED: 'signup_clicked',

  SCAN_WEB_CLICKED: 'scan_web_clicked',
  SCAN_WEB_STARTED: 'scan_web_started',
  SCAN_WEB_COMPLETED: 'scan_web_completed',
  SCAN_WEB_FAILED: 'scan_web_failed',
  SCAN_WEB_AGAIN_CLICKED: 'scan_web_again_clicked',
  SCAN_WEB_CANCEL_CLICKED: 'scan_web_cancel_clicked',

  // Onboarding space
  SHARE_PROFILE_CLICKED: 'share_profile_clicked',
  EDIT_PROFILE_CLICKED: 'edit_profile_clicked',
  PROFILE_PREVIEW_CLICKED: 'profile_preview_clicked',
  COPY_SUBDOMAIN_CLICKED: 'copy_subdomain_clicked',
  PROFILE_PREVIEW_CARD_CLICKED: 'profile_preview_card_clicked',

  // Services Migrator V3
  IMPORT_SERVICES_CLICKED: 'import_services_clicked',
  IMPORT_FROM_IMAGE_CLICKED: 'import_from_image_clicked',
  IMPORT_FROM_WEBPAGE_CLICKED: 'import_from_webpage_clicked',
  UPLOAD_CLICKED: 'upload_clicked',
  NOT_NOW_CLICKED: 'not_now_clicked',
  CONTINUE_CLICKED: 'continue_clicked',
  ADD_YOUR_SERVICES_CLICKED: 'add_your_services_clicked',
  BLANK_SERVICE_PAGE_OPENED: 'blank_service_page_opened',
  GO_BACK_TO_SELECTION_CLICKED: 'go_back_to_selection_clicked',
  CONTINUE_EDITING_CLICKED: 'continue_editing_clicked',
  START_AGAIN_CLICKED: 'start_again_clicked',
  ADD_NEW_SERVICE_CLICKED: 'add_new_service_clicked',
  ADD_SUGGESTED_SERVICE: 'add_suggested_service',
  ADD_MORE_CLICKED: 'add_more_clicked',

  IMPORT_STARTED: 'import_started',
  IMPORT_COMPLETED: 'import_completed',
  IMPORT_TRY_AGAIN: 'import_try_again',
  IMPORT_MISSING_INFORMATION: 'import_missing_information',
  FILL_MISSING_INFO_CLICKED: 'fill_missing_info_clicked',
  TRY_AGAIN_CLICKED: 'try_again_clicked',

  SHOW_SUGGESTIONS_CLICKED: 'show_suggestions_clicked',
  SUGGEST_SERVICE_CLICKED: 'suggest_service_clicked',

  BOOST_COMMISSION_INFO_CLICKED: 'boost_commission_info_clicked',

  SUSPEND_CLICKED: 'suspend_clicked',

  // No Show Protection
  ADD_RULE_CLICKED: 'add_rule_clicked',
  EDIT_RULE_CLICKED: 'edit_rule_clicked',
  DELETE_RULE_CLICKED: 'delete_rule_clicked',
  AUTO_CHARGE_CF_CLICKED: 'auto_charge_cf_clicked',
  APPLY_SERVICES_CLICKED: 'apply_services_clicked',
  CHANGE_PERCENT_CLICKED: 'change_percent_clicked',
  CHANGE_FIXED_PRICE_CLICKED: 'change_fixed_price_clicked',

  // Google Business Profile
  CANCEL_PROCESS_CLICKED: 'cancel_process_clicked',
  TOKEN_OBTAINED: 'token_obtained',
  TOKEN_ERROR: 'token_error',
  TOKEN_CANCELLED: 'token_cancelled',
  ADD_LOCATION_CLICKED: 'add_location_clicked',
  UPDATE_IN_BOOKSY_CLICKED: 'update_in_booksy_clicked',
  STATUS_CHANGED: 'status_changed',
  RESEND_CLICKED: 'resend_clicked',
  CHANGE_METHOD_CLICKED: 'change_method_clicked',
  TIMER_RUN_OUT: 'timer_run_out',
  RECEIVED_RESEND_ERROR: 'received_resend_error',

  // Customer details
  APPOINTMENTS_CLICKED: 'appointments_clicked',
  APPOINTMENTS_UPCOMING_CLICKED: 'appointments_upcoming_clicked',
  APPOINTMENTS_PAST_CLICKED: 'appointments_past_clicked',
  APPOINTMENT_BOOKING_CLICKED: 'appointment_booking_clicked',
  APPOINTMENT_BOOK_AGAIN_CLICKED: 'appointment_book_again_clicked',
  ABOUT_CLIENT_CLICKED: 'about_client_clicked',
  PAYMENTS_CLICKED: 'payments_clicked',
  THERAPY_CLICKED: 'therapy_clicked',
  MEMBERSHIP_CLICKED: 'membership_clicked',
  PACKAGES_CLICKED: 'packages_clicked',
  GIFT_CARDS_CLICKED: 'gift_cards_clicked',
  DOCUMENTS_CLICKED: 'documents_clicked',
  PHOTOS_CLICKED: 'photos_clicked',
  FAMILY_FRIENDS_CLICKED: 'family_friends_clicked',
  BOOKSY_MED_FAMILY_CLICKED: 'booksy_med_family_clicked',
  TAG_CLICKED: 'tag_clicked',
  INVITE_CLICKED: 'invite_clicked',
  EDIT_CLICKED: 'edit_clicked',
  NEW_APPOINTMENT_CLICKED: 'new_appointment_clicked',
  PRODUCTS_CLICKED: 'products_clicked',

  VISIBILITY_CLICKED: 'visibility_clicked',

  // Google Address
  GOOGLE_NAME_CLICKED: 'google_name_clicked',
  BOOKSY_NAME_CLICKED: 'booksy_name_clicked',
  NO_BUILDING_NUMBER_CLICKED: 'no_building_number_clicked',
  VIEW_RESULTS_LIST: 'view_results_list',
  NO_HINTS_VIEW_OPENED: 'no_hints_view_opened',
  PROCEED_STREET_NUMBER_CLICKED: 'proceed_street_number_clicked',
  INCORRECT_BUILDING_NUMBER_VIEW_OPENED: 'incorrect_building_number_view_opened',
  PIN_WARNING_SHOW_BANNER: 'pin_warning_show_banner',
  PIN_ERROR_SHOW_BANNER: 'pin_error_show_banner',
  TOO_GENERAL_LOCATION_SELECTED: 'too_general_location_selected',
  LOYALTY_PROGRAM_CLICKED: 'loyalty_program_clicked',
  LOYALTY_CARDS_CLICKED: 'loyalty_cards_clicked',
  SAVE_N_KEEP_CLICKED: 'save_n_keep_clicked',
  SAVE_N_VOID_CLICKED: 'save_n_void_clicked',
  DELETE_EXPIRED_CLICKED: 'delete_expired_clicked',
  DELETE_COMPLETED_CLICKED: 'delete_completed_clicked',
  DELETE_ALL_CLICKED: 'delete_all_clicked',
  CREATE_NEW_CLICKED: 'create_new_clicked',
  VISIBILITY_LEARN_MORE_CLICKED: 'visibility_learn_more_clicked',
  BOOK_NOW_TAB_CLICKED: 'book_now_tab_clicked',
  LINK_IN_BIO_TAB_CLICKED: 'link_in_bio_tab_clicked',
  LINK_COPIED: 'link_copied',

  SMS_CODE_SENT: 'sms_code_sent',
  TIPS_CLICKED: 'tips_clicked',
  SOCIAL_POST_CLICKED: 'social_post_clicked',
  HELP_CENTER_CLICKED: 'help_center_clicked',
  CONTACT_SUPPORT_CLICKED: 'contact_support_clicked',
}

export const PAGE_SOURCES = {
  CHECKOUT: 'checkout',
  SETTINGS: 'settings',
  CALENDAR: 'calendar',
  PAYMENTS_AND_CHECKOUT: 'payments_and_checkout',
}

export const HANDLER_METHODS = {
  IDENTIFY: 'identify',
  PUSH: 'push',
  TRACK: 'track',
  LOG_EVENT: 'logEvent',
}

export const SCREEN_NAMES = {
  PROFILE_SCREEN: 'profile_screen',
  SPLASH_GET_BCR: 'splash_get_bcr',
  SPLASH_CONNECT_BCR: 'splash_connect_bcr',
  SPLASH_TAP_TO_PAY: 'splash_tap_to_pay',
  SPLASH_BLIK_FOR_FREE: 'splash_blik_for_free',
  PAYMENT_METHOD: 'payment_method',
  OVERDUE_PAYMENT: 'overdue_payment',
  CHANGE_LANGUAGE: 'change_language',
  CHANGE_ACCOUNT: 'change_account',
  LANGUAGE_SETTINGS: 'language_settings',
  CALENDAR: 'calendar',
  CHECK_PROFILE_MODAL: 'check_profile_modal',
  YOUR_SUBSCRIPTION: 'your_subscription',
  BOOST_DASHBOARD: 'boost_dashboard',
  ONLINE_BOOKING: 'online_booking',
  INSTAGRAM_BOOKINGS: 'instagram_bookings',
  OFFLINE_BOOKING: 'offline_booking',
  INSTAGRAM_INTEGRATION: 'instagram_integration',
  FACEBOOK_INTEGRATION: 'facebook_integration',
  WEBSITE_INTEGRATION: 'website_integration',
  GOOGLE_INTEGRATION: 'google_integration',
  SEARCH_VISIBILITY: 'search_visibility',
  CANT_GO_OFFLINE: 'cant_go_offline',
  GO_OFFLINE: 'go_offline',
  SPLASH_BOOST_WARNING: 'splash_boost_warning',
  SERVICE_SETUP: 'service_setup',
  SERVICE_SETUP_LIST: 'service_setup_list',
  ADDING_EDITING_SERVICE: 'adding_editing_service',
  REFUND_ANNOUNCEMENT_SPLASH: 'refund_announcement_splash',

  // main application tabs
  APPOINTMENTS: 'appointments',
  CLIENT_CARDS: 'client_cards',
  CHECKOUT: 'checkout',
  GIFT_CARDS: 'gift_cards',
  INVENTORY: 'inventory',
  MARKETING: 'marketing',
  REPORTS: 'reports',
  STAFF: 'staff',
  TURN_TRACKER: 'turn_tracker',
  PROFILE: 'profile',
  INSTAGRAM_SELECT_PHOTO: 'instagram_select_photo',
  MESSAGE_BLASTS: 'message_blasts',
  PROMOTIONS: 'promotions',
  CHOOSE_CATEGORY: 'choose_category',
  SPLASH_USE_TAP_TO_PAY: 'splash_tap_to_pay',
  BOOKSY_WALLET: 'booksy_wallet',

  // experiments
  TRIAL_END_BLOCKED: 'trial_end_blocked',
  BOOST_APPOINTMENT_CANCELLATION: 'boost_appointment_cancellation',

  // checkout
  CHECKOUT_START: 'checkout_start',
  CHECKOUT_OTHER_PAYMENT_METHODS: 'checkout_other_payment_methods',
  CHECKOUT_COMPLETE: 'checkout_complete',
  CHECKOUT_CARD_ENTRY: 'checkout_card_entry',

  // promotions
  PREMIUM_HOURS: 'premium_hours',
  PREMIUM_HOURS_MODAL: 'premium_hours_modal',
  PREMIUM_HOURS_INCENTIVE_MODAL: 'premium_hours_incentive_modal',

  // payments
  PAYMENTS_NO_SUBSCRIPTION: 'payments_no_subscription',
  PAYMENTS_MARKETING_SCREEN: 'payments_marketing_screen',
  REFUND_OPTION: 'refund_option',
  REFUND_CONFIRMATION: 'refund_confirmation',

  // blik
  BANNER_BLIK_PREPAYMENTS: 'banner_blik_prepayments',
  BANNER_BLIK_FOR_FREE: 'banner_blik_for_free',

  BANNER_MONEY_IN_ACCOUNT: 'banner_money_in_account',
  BANNER_BOOKSY_WRAPPED: 'banner_wrapped',
  BUILDING_NUMBER: 'building_number',

  // [eppo] Experiment_Action/Variation_Assigned
  EXPERIMENT_ASSIGNMENT: 'experiment_assignment',

  PROFILE_PUBLICATION_FLOW: 'profile_publication_flow',
  PROFILE_PUBLICATION_FLOW_NEXT: 'profile_publication_flow_next',

  COVER_PHOTO: 'cover_photo',
  PORTFOLIO_MAIN: 'portfolio_main',
  SERVICES: 'services',
  BUSINESS_HOURS: 'business_hours',
  OTHER: 'other',

  LOGIN_EMAIL: 'login_email',
  LOGOUT_MODAL: 'logout_modal',

  ACCOUNT_SETTINGS: 'account_settings',

  // onboarding
  ONBOARDING_SHARE_YOUR_PROFILE: 'onboarding_share_your_profile',
  PASSWORD_RESET: 'password_reset',
  BUSINESS_REGISTRATION_STARTED_WITH_EMAIL: 'business_registration_started_with_email',
  SMS_VERIFICATION: 'sms_verification',

  // business status modals
  TRIAL_HAS_EXPIRED: 'trial_has_expired',
  TRIAL_WILL_EXPIRE: 'trial_will_expire',

  // modals
  ECOMMERCE_MODAL: 'ecommerce_modal',
  ECOMMERCE_HOLIDAY_MODAL: 'ecommerce_holiday_modal',
  ECOMMERCE_SUGGESTIONS_MODAL: 'product_suggestions_modal',

  // Booksy Pay
  BOOKSY_PAY_ONBOARDING: 'booksy_pay_onboarding',
  BOOKSY_PAY_ACTIVATION_SCREEN: 'booksy_pay_activation_screen',
  BOOKSY_PAY_LEARN_MORE: 'booksy_pay_learn_more',

  BOOKSY_PAY_PRICING: 'booksy_pay_pricing',

  // Google Business Profile
  STARTING_PAGE: 'starting_page',
  CANCEL_PROCESS_CONFIRMATION: 'cancel_process_confirmation',
  ACCOUNT_SELECTION: 'account_selection',
  NO_LOCATIONS: 'no_locations',
  LOCATION_SELECTION: 'location_selection',
  LOCATION_CREATION: 'location_creation',
  LOCATION_UPDATE: 'location_update',
  LOCATION_STATUS: 'location_status',
  VERIFICATION_METHOD: 'verification_method',
  VERIFICATION_CODE: 'verification_code',

  // No-Show Protection
  NSP_DASHBOARD_DEPOSIT: 'nsp_dashboard_deposit',
  NSP_DASHBOARD_CF: 'nsp_dashboard_cf',
  NSP_DEPOSIT_ADD_RULE: 'nsp_deposit_add_rule',
  NSP_DEPOSIT_EDIT_RULE: 'nsp_deposit_edit_rule',
  NSP_CF_ADD_RULE: 'nsp_cf_add_rule',
  NSP_CF_EDIT_RULE: 'nsp_cf_edit_rule',
  NSP_SETUP_ERROR: 'nsp_setup_error',
  NSP_SPLASH_BOOKING_MODE: 'nsp_splash_booking_mode',
  NSP_SPLASH_REVENUE_LOSS: 'nsp_splash_revenue_loss',
  NSP_SPLASH_HIGHER_DEPOSIT: 'nsp_splash_higher_deposit',
  NSP_SPLASH_KEEP_HIGHER_DEPOSIT: 'nsp_splash_keep_higher_deposit',

  // Visibility Promotion
  VISIBILITY_MODAL: 'visibility_modal',
  VISIBILITY_MODAL_FEEDBACK: 'visibility_modal_feedback',
  VISIBILITY_MODAL_CONFIRMATION: 'visibility_modal_confirmation',
  VISIBILITY_DASHBOARD: 'visibility_dashboard',
  VISIBILITY_COMPLETE_PAYMENT: 'visibility_complete_payment',
  VISIBILITY_STATUS: 'visibility_status',
  VISIBILITY_MODAL_SWITCH_FROM_BOOST: 'visibility_modal_switch_from_boost',

  // Google Address
  GOOGLE_MAPS: 'google_maps',
  GOOGLE_MAPS_ADDRESS: 'google_maps_address',
  GOOGLE_MAPS_BIZ_NAME: 'google_maps_biz_name',
  GOOGLE_MAPS_COMBINED: 'google_maps_combined',
  GOOGLE_MAPS_CONFIRM_BIZ_NAME: 'google_maps_confirm_biz_name',
  GOOGLE_MAPS_LOCATION: 'google_maps_location',
  GOOGLE_MAPS_PIN_ADJUSTMENT: 'google_maps_pin_adjustment',

  // Customers
  CUSTOMER_DETAILS: 'customer_details',
  SHARED_LOCATION: 'shared_location',

  // Loyalty program
  LP_ACTIVATION: 'lp_activation',
  LP_PROGRAM_TYPE: 'lp_program_type',
  LP_SETTINGS: 'lp_settings',
  LP_TERMS_CONDITIONS: 'lp_terms_conditions',
  LP_ENABLED: 'lp_enabled',
  LP_MAIN_SCREEN: 'lp_main_screen',
  LP_SAVE_CHANGES: 'lp_save_changes',
  LC_CARDS: 'lc_cards',
  LC_MANAGE: 'lc_manage',

  // Value proposition
  VALUE_PROPOSITION_INTRO: 'value_proposition_intro',
  VALUE_PROPOSITION_VALUES: 'value_proposition_values',

  // Platform fee settings
  PLATFORM_FEE_SETTINGS: 'platform_fee_settings',

  // Policies and safety
  BUSINESS_SETTINGS_POLICIES_AND_SAFETY: 'business_settings_policies_and_safety',

  // Business Details dashboard
  BUSINESS_SETTINGS_DETAILS: 'business_settings_details',
}

export const ENTRANCE_PATH = {
  APPOINTMENT_DETAILS: 'appointment_details',
  MENU: 'menu',
  OTHER: 'other',
  PAYMENTS_AND_CHECKOUT: 'payments_and_checkout',
  PAYMENTS_MARKETING_SCREEN: 'payments_marketing_screen',
  DEEPLINK: 'deeplink',
  NOTIFICATION: 'notification',
  ONLINE_GIFTCARD: 'online_giftcard',
  PROFILE: 'profile',
  CHECKOUT_PAYMENT_METHOD: 'checkout_payment_method',
  CALENDAR: 'calendar',
  RECEIPT: 'receipt',
  BP_APPT_CANCELLATION: 'bp_appt_cancellation',
  CHECKOUT_SETTINGS: 'checkout_settings',
  WALLET_NOTIFICATION: 'wallet_notification',
}

export const NSP_ENTRANCE_PATHS = [
  SCREEN_NAMES.NSP_DEPOSIT_ADD_RULE,
  SCREEN_NAMES.NSP_DEPOSIT_EDIT_RULE,
  SCREEN_NAMES.NSP_CF_ADD_RULE,
  SCREEN_NAMES.NSP_CF_EDIT_RULE,
  SCREEN_NAMES.NSP_SPLASH_BOOKING_MODE,
  SCREEN_NAMES.NSP_SPLASH_HIGHER_DEPOSIT,
  SCREEN_NAMES.NSP_SPLASH_KEEP_HIGHER_DEPOSIT,
  SCREEN_NAMES.NSP_SPLASH_REVENUE_LOSS,
]

export const NSP_MODAL_NAMES = {
  NSP_CLEARING_ALL_DEPOSITS: 'nsp_clearing_all_deposits',
  NSP_CLEARING_ALL_CF: 'nsp_clearing_all_cf',
}

export const NSP_SETUP_ERROR_MODAL_NAMES = {
  NSP_CLEARING_ALL_DEPOSITS: 'nsp_clearing_all_deposits',
  NSP_CLEARING_ALL_CF: 'nsp_clearing_all_cf',
  NSP_SERVICE_PRICING_CONFLICT: 'nsp_service_pricing_conflict',
  NSP_OVERWRITING_CONFLICT: 'nsp_overwriting_conflict',
  NSP_PRICE_LOWER_THAN_RULE: 'nsp_price_lower_than_rule',
  NSP_DELATE_RULE: 'nsp_delete_rule',
  NSP_DISCARD_CF_RULE: 'nsp_discard_cf_rule',
  NSP_DISCARD_DEPOSIT_RULE: 'nsp_discard_deposit_rule',
}

export const CHECKOUT_FAST_CHARGE = {
  CHARGE_CARD_ON_FILE: 'charge_card_on_file',
}

export const PAYMENTS_FEATURES = {
  ACCOUNT_VERIFICATION: 'account_verification',
  MOBILE_PAYMENTS: 'mobile_payments',
  NO_SHOW_PROTECTION: 'no_show_protection',
  BOOKSY_CARD_READER: 'booksy_card_reader',
  TAP_TO_PAY: 'tap_to_pay',
}

export const GA4_MEASUREMENT_ID = 'G-7F9B7WXS28'

export const BUSINESS_CATEGORIES_MARKETING_SCORE = {
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BARBERS]: 20000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HAIR_SALONS]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BRAIDS]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.NAIL_SALONS]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.SKIN_CARE]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.BROWS_AND_LASHES]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.AESTHETIC_MEDICINE]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HAIR_REMOVAL]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.MASSAGE]: 5500,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.DAY_SPA]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.MAKE_UP]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.WEDDING_MAKEUP_ARTIST]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HEALTH]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PHYSICAL_THERAPY]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PODIATRY]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.DENTAL]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PET_SERVICES]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HOLISTIC_MEDICINE]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.WEIGHT_LOSS]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PERSONAL_TRAINERS]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PSYCHOTHERAPY]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PIERCING]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.PROFESSIONAL_SERVICES]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.TATOO_ARTISTS]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HEALTH_AND_WELLNESS]: 1000,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.YOGA]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.HOME_SERVICES]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.AUTOMOTIVE]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.SHOPPING]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.FINANCIAL_INSTITUTIONS]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.TELECOM]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.CHIROPRACTIC]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.DIETICIAN]: 0,
  [BUSINESS_CATEGORY_INTERNAL_NAMES.OTHER]: 0,
}
